// extracted by mini-css-extract-plugin
var _1 = "WmhZI";
var _2 = "XLpX5";
export { _1 as "disabled", _2 as "reason" }
